import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface ButtonProps {
  children: ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
}

const variants = {
  primary: `
    bg-cyber-green/10 text-cyber-green border-cyber-green
    hover:bg-cyber-green/20 hover:shadow-[0_0_20px_rgba(0,255,65,0.4)]
  `,
  secondary: `
    bg-cyber-cyan/10 text-cyber-cyan border-cyber-cyan
    hover:bg-cyber-cyan/20 hover:shadow-[0_0_20px_rgba(0,240,255,0.4)]
  `,
  outline: `
    bg-transparent text-cyber-text border-cyber-muted
    hover:border-cyber-green hover:text-cyber-green
  `,
};

export function Button({
  children,
  href,
  onClick,
  variant = 'primary',
  className = ''
}: ButtonProps) {
  const baseClasses = `
    inline-flex items-center gap-2 px-6 py-3
    border-2 rounded font-mono text-sm uppercase tracking-wider
    transition-all duration-300 cursor-pointer
    ${variants[variant]}
    ${className}
  `;

  const MotionComponent = href ? motion.a : motion.button;

  return (
    <MotionComponent
      href={href}
      onClick={onClick}
      className={baseClasses}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      target={href?.startsWith('http') ? '_blank' : undefined}
      rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
    >
      {children}
    </MotionComponent>
  );
}
